customElements.get("splide-component") ||
  customElements.define(
    "splide-component",
    class extends HTMLElement {
      constructor() {
        (super(),
          (this.sliderContainer = this.querySelector(".splide")),
          document.addEventListener("shopify:section:load", (e) => {
            this.initializeSlider();
          }));
      }
      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () =>
          this.initializeSlider(),
        );
      }
      initializeSlider() {
        ((this.videoSlider = this.dataset.videoSlider),
          (this.sliderType = this.dataset.type || "slide"),
          (this.sliderTypeMobile = this.dataset.typeMobile || this.sliderType),
          (this.sliderDirection = this.dataset.direction || "ltr"),
          (this.rewindSlider = "fade" === this.sliderType),
          (this.autoPlayEnabled = "true" === this.dataset.autoplay),
          (this.autoPlaySpeed =
            this.dataset.autoplaySpeed &&
            !isNaN(parseInt(this.dataset.autoplaySpeed))
              ? 1e3 * parseInt(this.dataset.autoplaySpeed)
              : 5e3),
          (this.dragMode =
            "false" !== this.dataset.drag &&
            ("free" !== this.dataset.drag || "free")),
          (this.focusSlide = this.dataset.focus || 0),
          (this.trimSpaceEnabled = "false" !== this.dataset.trimSpace),
          (this.arrowsEnabled = "false" !== this.dataset.arrows),
          (this.paginationEnabled = "false" !== this.dataset.pagination),
          (this.omitEndEnabled = !0),
          (this.slidesPerPageDesktop =
            this.dataset.slidesDesktop &&
            !isNaN(parseInt(this.dataset.slidesDesktop))
              ? parseInt(this.dataset.slidesDesktop)
              : 3),
          (this.autoWidthEnabled = this.dataset.autoWidthEnabled),
          (this.slidesPerPageMobile =
            this.dataset.slidesMobile &&
            !isNaN(parseInt(this.dataset.slidesMobile))
              ? parseInt(this.dataset.slidesMobile)
              : 1),
          (this.slidesPerMoveDesktop =
            this.dataset.perMoveDesktop &&
            !isNaN(parseInt(this.dataset.perMoveDesktop))
              ? parseInt(this.dataset.perMoveDesktop)
              : 1),
          (this.slidesPerMoveMobile =
            this.dataset.perMoveMobile &&
            !isNaN(parseInt(this.dataset.perMoveMobile))
              ? parseInt(this.dataset.perMoveMobile)
              : 1),
          (this.gapBetweenSlidesDesktop = this.dataset.gapDesktop
            ? parseInt(this.dataset.gapDesktop)
            : 30),
          (this.gapBetweenSlidesMobile = this.dataset.gapMobile
            ? parseInt(this.dataset.gapMobile)
            : 15),
          (this.paddingCalculationDesktop =
            "true" === this.dataset.paddingCalcDesktop),
          (this.rightPaddingDesktop =
            parseInt(this.dataset.sidePaddingDesktop) || 0),
          (this.leftPaddingDesktop = this.paddingCalculationDesktop
            ? 0
            : this.rightPaddingDesktop),
          (this.paddingCalculationMobile =
            "true" === this.dataset.paddingCalcMobile),
          (this.rightPaddingMobile =
            parseInt(this.dataset.sidePaddingMobile) || 0),
          (this.leftPaddingMobile = this.paddingCalculationMobile
            ? 0
            : this.rightPaddingMobile),
          (this.destroySliderDesktop = "true" === this.dataset.destroyDesktop),
          (this.destroySliderMobile = "true" === this.dataset.destroyMobile),
          (this.sliderConfig = {
            type: this.sliderType,
            direction: this.sliderDirection,
            rewind: this.rewindSlider,
            autoplay: this.autoPlayEnabled,
            interval: this.autoPlaySpeed,
            drag: this.dragMode,
            focus: this.focusSlide,
            trimSpace: this.trimSpaceEnabled,
            arrows: this.arrowsEnabled,
            pagination: this.paginationEnabled,
            omitEnd: this.omitEndEnabled,
            perPage: this.slidesPerPageDesktop,
            perMove: this.slidesPerMoveDesktop,
            autoWidth: this.autoWidthEnabled,
            gap: this.gapBetweenSlidesDesktop,
            padding: {
              left: this.leftPaddingDesktop,
              right: this.rightPaddingDesktop,
            },
            destroy: this.destroySliderDesktop,
            classes: {
              arrow: "splide__arrow slider-button",
              page: "splide__pagination__page",
            },
            easing: "cubic-bezier(0.25, 1, 0.5, 1)",
            breakpoints: {
              749: {
                omitEnd: this.omitEndEnabled,
                type: this.sliderTypeMobile,
                perPage: this.slidesPerPageMobile,
                perMove: this.slidesPerMoveMobile,
                gap: this.gapBetweenSlidesMobile,
                padding: {
                  left: this.leftPaddingMobile,
                  right: this.rightPaddingMobile,
                },
                destroy: this.destroySliderMobile,
              },
            },
          }),
          console.log("Slider Config:", this.sliderConfig),
          console.log("Slider Breakpoints:", this.sliderConfig.breakpoints));
        const e = new Splide(this.sliderContainer, this.sliderConfig);
        if (
          (e.on("mounted", () => {
            const t = e.index,
              i = e.Components.Elements.slides[t];
            if (i) {
              const e = i.querySelector("img");
              e
                ? e.complete
                  ? (i.classList.add("is-instant-active"),
                    this.setActiveSlideHeight(i))
                  : e.addEventListener("load", () => {
                      (i.classList.add("is-instant-active"),
                        this.setActiveSlideHeight(i));
                    })
                : (i.classList.add("is-instant-active"),
                  this.setActiveSlideHeight(i));
            }
          }),
          e.on("move", () => {
            const t = e.index,
              i = e.Components.Elements.slides;
            if (i) {
              const e = i[t];
              ("false" === this.dataset.videoAutoplay &&
                "true" == this.dataset.videoSlider &&
                i.forEach((e, i) => {
                  const s = e.querySelector("video"),
                    a = e.querySelector(".video-play_button");
                  s &&
                    (i === t
                      ? ((s.currentTime = 0),
                        s.play(),
                        a && a.classList.add("hidden"))
                      : (s.pause(), a && a.classList.remove("hidden")));
                }),
                e &&
                  (i.forEach((e) => e.classList.remove("is-instant-active")),
                  e.classList.add("is-instant-active"),
                  this.setActiveSlideHeight(e)));
            }
          }),
          "true" === this.dataset.pauseVideos &&
            e.on("hidden", (e) => {
              const t = e.slide.querySelector("internal-video");
              if (t) {
                const e = t.dataset.actionOnInactive;
                "pause" === e
                  ? (t.video.pause(),
                    t.classList.remove("internal-video--playing"))
                  : "mute" === e &&
                    ((t.video.muted = !0),
                    t.classList.add("internal-video--muted"));
              }
            }),
          e.mount(),
          "true" !== this.dataset.videoAutoplay &&
            "true" == this.dataset.videoSlider)
        ) {
          const e = this.querySelectorAll("video");
          e.forEach((t) => {
            const i = t.closest(".video_slider"),
              s = t.nextElementSibling;
            i &&
              (t.addEventListener("ended", () => {
                s && s.classList.remove("hidden");
              }),
              i.addEventListener("click", (i) => {
                (i.preventDefault(),
                  t.paused
                    ? (t.play(),
                      s && s.classList.add("hidden"),
                      e.forEach((e) => {
                        if (e !== t) {
                          e.pause();
                          const t = e.nextElementSibling;
                          t && t.classList.remove("hidden");
                        }
                      }))
                    : (t.pause(), s && s.classList.remove("hidden")));
              }));
          });
        }
      }
      setActiveSlideHeight(e) {
        if (e) {
          const t = e.offsetHeight;
          this.style.setProperty("--active-slide-height", `${t}px`);
        }
      }
    },
  );
